import { createActionNamespace } from 'Modules/core/redux';

import { GetItemType, IError, IStatus } from './types';


const newsAction = createActionNamespace('news');


export const newsActions = {
    setStatus: newsAction<IStatus>('SET_STATUS'),
    setError: newsAction<IError>('SET_ERROR'),
    getItem: newsAction<GetItemType>('GET_ITEM'),
};
